var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagenCarrito(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 436,
    viewBox: "0 0 426 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.14,
    cy: 237.818,
    rx: 198.14,
    ry: 198.182,
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.6459 271.917H306.014C313.246 271.917 318.299 279.15 315.723 285.987C304.825 314.922 272.529 357.234 197.83 357.234C123.132 357.234 90.8348 314.922 79.9371 285.987C77.3613 279.15 82.4138 271.917 89.6459 271.917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.734 183.032C233.616 183.032 245.681 170.965 245.681 156.079C245.681 141.194 233.616 129.126 218.734 129.126C203.851 129.126 191.787 141.194 191.787 156.079C191.787 170.965 203.851 183.032 218.734 183.032Z",
    fill: "#D2D2D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.664 246.252C168.352 246.252 181.88 232.721 181.88 216.029C181.88 199.338 168.352 185.807 151.664 185.807C134.976 185.807 121.447 199.338 121.447 216.029C121.447 232.721 134.976 246.252 151.664 246.252Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.743 261.314C229.069 261.314 238.25 252.13 238.25 240.802C238.25 229.474 229.069 220.29 217.743 220.29C206.417 220.29 197.236 229.474 197.236 240.802C197.236 252.13 206.417 261.314 217.743 261.314Z",
    fill: "#D2D2D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250.733 222.767L297.197 176.294C297.197 176.294 306.807 229.605 250.733 222.767Z",
    fill: "#D2D2D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.787 109.606L145.323 156.079C145.323 156.079 135.713 102.768 191.787 109.606Z",
    fill: "#D2D2D2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagenCarrito);
export default __webpack_public_path__ + "static/media/ImagenCarrito.1672973e072d6b02b8b71600c8f6f95f.svg";
export { ForwardRef as ReactComponent };